import { Currency } from "../../ProductService/NormasTeachingProduct/useNormasTeachingProductById.ts";

export function mapCurrencyToSymbol(currency: Currency): string {
  switch (currency) {
    case Currency.Eur:
      return "€";
    default:
      return currency;
  }
}
